/**
 * 该文件统一配置系统级className常量
 */

// SearchSelect宽表搜索组件，在父容器滚动时，自动关闭，需要给父容器加这个className
export const SEARCH_SELECT_COMP_AUTO_CLOSE_WHEN_SCROLL_NODE = 'dbg-search-select-comp-auto-close-when-scroll-node';
